import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { UserService } from 'src/app/root/_services/user.service';
import { AlertService } from 'src/app/root/_services/alert.service';
import { Lingua } from '../../_models/lingua';
import { LanguageService } from 'src/app/root/_services/language.service';
import { CommonService } from 'src/app/root/_services/common.service';
import { ItmComboBoxItem } from 'src/app/shared/form-control/itm-combobox/itm-combobox.component';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AppConfig } from 'src/app/app.config';

@Component({
	selector: 'app-register',
	templateUrl: './register.component.html',
	styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

	fg: FormGroup
	registered: boolean = true;
	linguaList: Array<Lingua>;
	nazioniList: Array<ItmComboBoxItem>;
	registrazioneOk = false;
	forceValidation = false;
	
	constructor(
		private fb: FormBuilder,
		private userService: UserService,
		private alertService: AlertService,
		private languageService: LanguageService,
		private commonService: CommonService,
		private translateService: TranslateService,
		private router: Router,
		private config: AppConfig
	) { }

	ngOnInit() {
		this.createFormGroup();
		this.loadCombo();
	}

	loadCombo() {
		this.languageService.getAll()
			.subscribe(
				data => {
					if (data.status == "OK")
						this.linguaList = this.languageService.mapLanguages(data.result.data);
					else {
						this.alertService.error(data.error_message ? data.error_message : "SYSTEM ERROR");
						this.linguaList = [];
					}
				});
		this.commonService.getNazioni().subscribe(
			data => {
				if (data.status == "OK")
					this.nazioniList = (<Array<any>>data.result.data).map(
						v => <ItmComboBoxItem>{ "descr": v.nome, "value": v.id }
					);
				else if (data.error_message)
					this.alertService.error(data.error_message);
				else
					this.alertService.error("SYSTEM ERROR");
			});
	}

	createFormGroup() {
		this.fg = this.fb.group({
			nome: ['', Validators.required],
			cognome: ['', Validators.required],
			email: ['', [Validators.required, Validators.email]],
			password: ['', [Validators.required, Validators.minLength(8), Validators.pattern(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/)]],
			conferma_password: ['', [Validators.required, Validators.minLength(8), Validators.pattern(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/)]],
			lingua: ['it', Validators.required],
			ragioneSociale: [''],
			pIva: [''],
			citta: [''],
			nazione: [''],
			condizioni: [null, Validators.requiredTrue]
		},
			{
				validator: this.checkPassword('password', 'conferma_password')
			});
	}

	canSubmit(): boolean {
		return this.fg.valid;
	}

	onSubmit() {
		this.forceValidation = false;
		if (this.canSubmit()) {
			this.userService.register(this.fg.value).subscribe(
				res => {
					if (res.status == "OK") {
						if (res.result.valid)
							//this.alertService.success(this.translateService.instant("register.registrazione_ok"));
							this.registrazioneOk = true;
						else if (res.result.error_messages)
							this.alertService.error(res.result.error_messages.join("<br/>"));
					} else if (res.error_message)
						this.alertService.error(res.error_message);
					else
						this.alertService.error("SYSTEM ERROR");
				});
		}
		else
			this.forceValidation = true;
	}

	login() {
		this.router.navigate(["/login"]);
	}

	checkPassword(Controllo: string, ctrlCollegato: string) {
		return (formGroup: FormGroup) => {
			const control = formGroup.controls[Controllo];
			const ControlliCollegati = formGroup.controls[ctrlCollegato];
			if (ControlliCollegati.errors && !ControlliCollegati.errors.NonUguali) {
				return;
			}
			if (control.value !== ControlliCollegati.value) {
				ControlliCollegati.setErrors({ NonUguali: true });
			} else {
				ControlliCollegati.setErrors(null);
			}
		};
	}

	condizioni(){
		window.open(this.config.getConfig("urlCondizioniServizio"), "_blank");
	}

}
